export default "__VITE_ASSET__CLhdPP0u__"